import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ComponentOpaqueDetail from '../../components/component_opaque/ComponentOpaqueDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  getComponentOpaque,
  editMaterialComponent,
} from '../../redux/component_opaque/component_actions';

class ComponentOpaqueEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.componentDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.component !== nextProps.component) && nextProps.show) {
      this.props.getComponent(nextProps.component.id);
    }
  }

  onSaveHandler() {
    const editedComponent = this.componentDetail.getWrappedInstance().getWrappedInstance().getComponentData();
    this.props.editComponent({
      ...editedComponent,
      id: this.props.component.id,
    });
  }

  render() {
    const { isEditing, errorMessage, componentDetail, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit opaque component')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ComponentOpaqueDetail
            component={componentDetail}
            ref={ref => (this.componentDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="component-opaque-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.component.opaque.errorMessage,
  isEditing: state.component.opaque.isEditing,
  componentDetail: props.component && state.component.opaque.components[props.component.id],
});

const mapDispatchToProps = dispatch => ({
  editComponent: component => defaultRejectHandler(dispatch(editMaterialComponent(component.id, component.name, component.solar_absorptance_id, component.heat_dissipation_id, component.description, component.image))),
  getComponent: id => dispatch(getComponentOpaque(id)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentOpaqueEditModal)
);



// WEBPACK FOOTER //
// ./src/modal/component_opaque/ComponentOpaqueEditModal.js